/**
 * How it speaks Arabic (spec §7 P-7.2, owner decision O-4). Pure: no Vue, no I/O.
 *
 * The sidecar owns the two config-bag keys (`ai-sidecar/src/arabic-voice.ts`) and reads them
 * strictly; the BFF sends both, always (`arabicFormal: false`, `speaksAs: null` when unset).
 * Personality shows them as two choices that ride the Save bar like "Your customers write in":
 * on this page a switch saves the moment it is flipped (P-5.1), and these are drafts.
 */

/** "Speaks as". `null` is "not chosen": it avoids gendered words (O-4, the default). */
export const SPEAKS_AS = ['she', 'he'];

/** The three "Speaks as" cards, the unset one first because it is everybody's default. */
export const SPEAKS_AS_CHOICES = ['none', ...SPEAKS_AS];

/** A card id to the stored value, and back. */
export const speaksAsOf = id => (SPEAKS_AS.includes(id) ? id : null);
export const speaksAsCard = value =>
  SPEAKS_AS.includes(value) ? value : 'none';

/** The register cards: match the customer (the default) or always formal. */
export const REGISTER_CHOICES = ['match', 'formal'];
export const registerCard = formal => (formal === true ? 'formal' : 'match');

/** The voice group means nothing to an account whose customers write English only. */
export const showsArabicVoice = languages => languages !== 'en';
